import AbstractFileList from './AbstractFIleList';
export default class SharedFileList extends AbstractFileList {
  loadFileList() {
    this.fileState.loadResults();
  }
  hasMoreResults() {
    return this.fileState.hasMoreResults();
  }
  loadMore() {
    this.fileState.loadMore();
  }
  isLoading() {
    return this.fileState.isLoading();
  }
  fileCollection() {
    return this.fileState.files;
  }
}
flarum.reg.add('fof-upload', 'common/components/SharedFileList', SharedFileList);